import ApiService from './../api/ApiService';
import Urls from './../api/Urls';
import Config from '../constants/Config';
import Product from '../models/Product';

export function getProducts(params) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.PRODUCT_LIST,
        params: params,
        parser: productsDataParser,
    }).get();
}

export function getAllProducts(params) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.PRODUCT_LIST_ALL,
        params: params,
        parser: productsAllDataParser,
    }).get();
}

export function getProductDetail(id) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.PRODUCT_DETAIL,
        endpointParams: { id },
        parser: data => new Product(data.data),
    }).get();
}

export function createProduct(product) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.PRODUCT_CREATE,
    }).post(product.export());
}

export function updateProduct(product) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.PRODUCT_UPDATE,
    }).put(product.export());
}

export function deleteProduct(id) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.PRODUCT_DELETE,
        endpointParams: { id },
    }).delete();
}

export function createProductTranslate(product) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.PRODUCT_TRANSLATE_CREATE,
    }).post(product.export(true).translate());
}

export function updateProductTranslate(product) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.PRODUCT_TRANSLATE_UPDATE,
    }).put(product.export(true).translate());
}

export function deleteProductTranslate(id) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.PRODUCT_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}


function productsDataParser(data = {}) {
    return {
        ...data.data,
        result: (data.data.result || []).map(item => new Product(item))
    }
}

function productsAllDataParser(data = {}) {
    return (data.data || []).map(item => new Product(item))
}